/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';

export const fetchEmailsForThread = createRoutine('FETCH_EMAILS_FOR_THREAD');
export const fetchLinkedEntitiesForThread = createRoutine(
  'FETCH_LINKED_ENTITIES_FOR_THREAD'
);
export const updateThreadByStatus = createRoutine('UPDATE_THREAD_BY_STATUS');
export const updateThreadByLinkingEntities = createRoutine(
  'UPDATE_THREAD_BY_LINKING_ENTITIES'
);
